import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as articlesApi from "@/api/articles.api";
import type { Article } from "@/types";

interface ArticlesState {
  latest: Article[];
  loading: boolean;
}

const initialState: ArticlesState = {
  latest: [],
  loading: false,
};

export const fetchLatestArticles = createAsyncThunk(
  "articles/fetchLatest",
  async (limit: number = 20) => {
    return await articlesApi.getLatestArticles(limit);
  },
);

const articlesSlice = createSlice({
  name: "articles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestArticles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLatestArticles.fulfilled, (state, action) => {
        state.latest = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestArticles.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default articlesSlice.reducer;
